import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import Validators from "Common/Validators";
import React, { useEffect, useState } from "react";
import PhoneInput, {
  isValidPhoneNumber,
  formatPhoneNumber,
  formatPhoneNumberIntl,
} from "react-phone-number-input";
import utils from "utils";
import api from "utils/api";
import SuperAdminModules from "./SuperAdminModules";
import SuperAdminModulesNew, {
  getOptionsForRole,
} from "./SuperAdminModulesNew";
const AddNewUser = (props) => {
  const [form] = Form.useForm();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [specialityOptions, setSpecialityOptions] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formActionState, setFormActionState] = useState(false);
  const [selectedRole, setSelectedRole] = useState({
    is_doctor: props?.editData?.is_doctor || false,
    is_super_admin: props?.editData?.is_super_admin || false,
    is_care_admin: props?.editData?.is_care_admin || false,
  });
  useEffect(() => {
    fetchOptions("speciality");
    fetchOptions("language");
  }, []);
  useEffect(() => {
    if (props?.editData) {
      setFieldsValue();
    }
  }, [props?.editData]);
  const is_doctor = selectedRole.is_doctor;
  function fetchOptions(search) {
    const query = new URLSearchParams({ search }).toString();
    api
      .language_speciality_list(`${query}`)
      .then((response) => {
        const fetchedOptions = response.data?.data?.results.map((item) => ({
          label: item.field_value,
          value: item.id,
        }));
        if (search === "language") {
          setLanguageOptions(fetchedOptions);
        } else if (search === "speciality") {
          setSpecialityOptions(fetchedOptions);
        }
      })
      .catch((error) => {
        console.error(`Failed to fetch ${search} options:`, error);
      });
  }
  const handleSubmit = async (values) => {
    const formattedMobileNumber = formatPhoneNumberIntl(values.mobile_number);
    const mobile_number =
      formattedMobileNumber?.split(" ").slice(1).join("") || "";
    const country_code = formattedMobileNumber?.split(" ")[0] || "";
    let initial_data = props?.editData || {};
    if (!Object.values(selectedRole).some((value) => value)) {
      message.info("No Role is selected");
      return;
    }
    let payload = {
      ...values,
      mobile_number,
      country_code,
      speciality: Array.isArray(values.speciality)
        ? values.speciality
        : [values.speciality],
      ...selectedRole,
      page_access: listToFlag(),
    };
    function checkKeys(obj) {
      for (const parentKey in obj) {
        if (Object.values(obj[parentKey]).every((value) => value === false)) {
          return true;
        }
      }
      return false;
    }
    if (checkKeys(payload.page_access)) {
      message.info("Minimum of one Module need to selected");
      return;
    }
    // Object.keys(payload).forEach((key) => {
    //   const initValue = initial_data[key];
    //   const currValue = payload[key];
    //   if (typeof currValue === "object" && !Array.isArray(currValue)) {
    //     if(!utils.isModified(initValue, currValue)){
    //       payload[key]={};
    //     }
    //   }
    // });

    if (props?.editData) {
      payload.user_id = props?.editData?.user_id;
      if (!utils.isModified(initial_data, payload)) {
        message.info("No changes detected");
        return;
      }

      if (!utils.isModified(initial_data.page_access, payload.page_access)) {
        payload["page_access"] = {};
      }
      const keysToExclude = [
        "is_doctor",
        "is_care_admin",
        "is_super_admin",
        // "page_access",
        "user_id",
      ];
      const { result } = utils.getFilteredValues(
        keysToExclude,
        props.editData,
        payload
      );
      payload = result;
    }

    try {
      const apiCall = props?.editData?.user_id
        ? api.update_user_details
        : api.user_registration;
      const response = await apiCall(payload);

      if (response.data?.status === 200) {
        if (props?.editData?.user_id) {
          message.success("Details updated successfully");
        } else {
          message.success("Successfully registered");
        }
        props?.submitButtonAction();
      } else {
        message.error(response.data?.message);
      }
    } catch (err) {
      message.error("Something went wrong");
    } finally {
      setButtonLoader(false);
    }
  };
  const handleRoleChange = (checkedValues) => {
    handleFieldChange();
    const roleState = {
      is_doctor: checkedValues.includes("is_doctor"),
      is_super_admin: checkedValues.includes("is_super_admin"),
      is_care_admin: checkedValues.includes("is_care_admin"),
    };

    setSelectedRole(roleState);
  };
  // const handleFieldChange = (changedValues, allValues) => {
  //   const { speciality } = changedValues;
  //   const initialSpeciality = Array.isArray(initialValues.speciality) ? initialValues.speciality[0] : initialValues.speciality;
  //   if (speciality !== undefined && props.editData) {
  //     if (speciality !== initialSpeciality) {
  //       form.setFields([
  //         { name: "specialization", errors: ["Specialization must be changed"] },
  //         { name: "designation", errors: ["Designation must be changed"] },
  //         { name: "display_designation", errors: ["Display_designation must be changed"] },
  //       ]);
  //     } else {
  //       form.setFields([
  //         { name: "specialization", errors: [] },
  //         { name: "designation", errors: [] },
  //         { name: "display_designation", errors: [] },
  //       ]);
  //     }
  //   }

  // props.formAction(true);
  // };
  const handleFieldChange = () => {
    const { formAction = null, formActionState = false } = props;
    if (!formActionState && formAction) {
      formAction(true);
    }
    setFormActionState(true);
  };
  function setFieldsValue() {
    if (props?.editData) {
      const {
        first_name,
        last_name,
        email,
        country_code,
        mobile_number,
        qualification,
        specialization,
        salutation,
        display_name,
        niyama_designation,
        display_designation,
        registration_number,
        speciality,
        languages,
      } = props.editData;

      const fullMobileNumber = `${country_code}${mobile_number}`;
      let selectedData = {
        first_name,
        last_name,
        email,
        mobile_number: fullMobileNumber,
      };
      if (is_doctor) {
        selectedData = {
          ...selectedData,
          qualification,
          specialization,
          salutation,
          display_name,
          niyama_designation,
          display_designation,
          registration_number,
          speciality,
          languages,
        };
      }
      form.setFieldsValue(selectedData);
      setInitialValues(selectedData);
    }
  }
  function listToFlag() {
    const modules = form.getFieldValue("modules") || {}; // Ensure `modules` is not undefined or null
    // console.log("Modules Data:", modules);

    const pageAccess = {};
    Object.keys(modules)
      .filter((role) => selectedRole[`is_${role}`])
      .forEach((role) => {
        pageAccess[role] = getOptionsForRole(role).reduce((obj, key) => {
          obj[key] = false;
          return obj;
        }, {});
        modules[role].forEach((module) => {
          pageAccess[role][module] = true;
        });
      });

    // console.log("Processed Page Access:", pageAccess);
    return pageAccess;
  }
  const handleCancel = () => {
    if (formActionState) {
      setIsModalOpen(true);
    } else {
      utils.Modal(false);
    }
  };
  return (
    <div>
      <Card
        title={`${props?.editData ? "Update" : "Add"} User`}
        className="newClinician"
      >
        <Form
          form={form}
          colon={false}
          size={"medium"}
          name="new_clinician"
          layout="horizontal"
          onFinish={handleSubmit}
          onFieldsChange={handleFieldChange}
          labelAlign="left"
          labelCol={{
            span: 10,
          }}
          wrapperCol={{
            span: 12,
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Select Role"
                labelCol={{
                  span: 5,
                }}
              >
                <Checkbox.Group
                  onChange={handleRoleChange}
                  value={Object.keys(selectedRole).filter(
                    (key) => selectedRole[key] === true
                  )}
                >
                  <Checkbox value="is_doctor">Doctor</Checkbox>
                  <Checkbox value="is_care_admin">Care Admin</Checkbox>
                  <Checkbox value="is_super_admin">Super Admin</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item
                name="first_name"
                label="First Name"
                rules={[
                  {
                    required: true,
                    message: ``,
                  },
                  Validators.validateFirstName,
                ]}
              >
                <Input disabled={props?.editData?.first_name} />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: `This field cannot be empty`,
                  },
                  Validators.checkEmail,
                ]}
              >
                <Input disabled={props?.editData?.email} />
              </Form.Item>
              {is_doctor && (
                <>
                  <Form.Item
                    name="qualification"
                    label="Qualification"
                    rules={[
                      {
                        required: true,
                        message: "please enter qualification",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="salutation"
                    label="Salutation"
                    rules={[
                      {
                        required: true,
                        message: "please enter salutation",
                      },
                    ]}
                  >
                    <Input disabled={props?.editData?.salutation} />
                  </Form.Item>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const currentSpeciality = getFieldValue("speciality");
                      const initialSpeciality = Array.isArray(
                        initialValues.speciality
                      )
                        ? initialValues.speciality[0]
                        : initialValues.speciality;
                      const specialityValue = Array.isArray(currentSpeciality)
                        ? currentSpeciality[0]
                        : currentSpeciality;
                      const specialityChanged =
                        specialityValue !== initialSpeciality;
                      return (
                        <>
                          <Form.Item
                            name="niyama_designation"
                            label="Designation"
                            dependencies={["speciality"]}
                            validateTrigger={["onChange", "onBlur"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter designation",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    specialityChanged &&
                                    value ===
                                      initialValues.niyama_designation &&
                                    value
                                  ) {
                                    return Promise.reject(
                                      new Error("Designation must be changed")
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    name="registration_number"
                    label="Registration Number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your registration number",
                      },
                    ]}
                  >
                    <Input disabled={props?.editData?.registration_number} />
                  </Form.Item>
                  <Form.Item
                    name="languages"
                    label="Language "
                    rules={[
                      {
                        required: true,
                        message: "please select language",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      mode="multiple"
                      placeholder="Select languages"
                      // onChange={handleChange}
                      // onFocus={() => fetchOptions("language")}
                      options={languageOptions}
                    />
                  </Form.Item>
                </>
              )}
            </Col>

            <Col span={12}>
              <Form.Item
                name="last_name"
                label="Last Name"
                rules={[Validators.validateLastName]}
              >
                <Input disabled={props?.editData?.last_name} />
              </Form.Item>
              <Form.Item
                name="mobile_number"
                label="Mobile Number"
                rules={[
                  { required: true, message: "" },
                  {
                    required: true,
                    validator: (_, value) =>
                      value
                        ? isValidPhoneNumber(value)
                          ? Promise.resolve()
                          : Promise.reject("Please enter a valid mobile number")
                        : Promise.reject(`Please enter mobile number`),
                  },
                ]}
              >
                <div className="mobile-input">
                  <PhoneInput
                    className="signup-mobile-input"
                    international={true}
                    defaultCountry="IN"
                    value={form.getFieldValue("mobile_number")}
                    onChange={(value) => {
                      form.setFieldsValue({ mobile_number: value });
                    }}
                    disabled={props?.editData?.mobile_number}
                  />
                </div>
              </Form.Item>
              {is_doctor && (
                <>
                  {" "}
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const currentSpeciality = getFieldValue("speciality");
                      const initialSpeciality = Array.isArray(
                        initialValues.speciality
                      )
                        ? initialValues.speciality[0]
                        : initialValues.speciality;
                      const specialityValue = Array.isArray(currentSpeciality)
                        ? currentSpeciality[0]
                        : currentSpeciality;
                      const specialityChanged =
                        specialityValue !== initialSpeciality;
                      return (
                        <>
                          <Form.Item
                            name="specialization"
                            label="Specialization"
                            dependencies={["speciality"]}
                            validateTrigger={["onChange", "onBlur"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter specialization",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    specialityChanged &&
                                    value === initialValues.specialization &&
                                    value
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        "Specialization must be changed"
                                      )
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    name="display_name"
                    label="Display Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your display name",
                      },
                    ]}
                  >
                    <Input disabled={props?.editData?.display_name} />
                  </Form.Item>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const currentSpeciality = getFieldValue("speciality");
                      const initialSpeciality = Array.isArray(
                        initialValues.speciality
                      )
                        ? initialValues.speciality[0]
                        : initialValues.speciality;
                      const specialityValue = Array.isArray(currentSpeciality)
                        ? currentSpeciality[0]
                        : currentSpeciality;
                      const specialityChanged =
                        specialityValue !== initialSpeciality;
                      return (
                        <>
                          <Form.Item
                            name="display_designation"
                            label="Display Designation"
                            dependencies={["speciality"]}
                            validateTrigger={["onChange", "onBlur"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter display designation",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    specialityChanged &&
                                    value ===
                                      initialValues.display_designation &&
                                    value
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        "Display designation must be changed"
                                      )
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </>
                      );
                    }}
                  </Form.Item>
                  <Form.Item
                    name="speciality"
                    label="Speciality"
                    rules={[
                      {
                        required: true,
                        message: "Please select speciality",
                      },
                    ]}
                  >
                    <Select
                      placeholder="select speciality"
                      // onFocus={() => fetchOptions("speciality")}
                      options={specialityOptions}
                      // mode="multiple"
                    />
                  </Form.Item>
                </>
              )}
            </Col>
          </Row>
          {selectedRole && (
            <div>
              <SuperAdminModulesNew
                selectedRole={Object.keys(selectedRole)
                  .filter((key) => selectedRole[key] === true)
                  .map((key) => key.replace("is_", ""))}
                form={form}
                editData={props?.editData}
                handleFieldChange={handleFieldChange}
              />
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              // marginRight: "100px",
              gap: "10px",
            }}
          >
            {!props?.editData && (
              <Form.Item>
                <Button onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            )}
            <Form.Item>
              <Button
                type="primary"
                loading={buttonLoader}
                htmlType="submit"
                style={{ background: "#12005F", color: "white" }}
              >
                {props?.editData ? "Update" : "Submit"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Card>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        className="unsavedpopup"
        width="600px"
        centered
      >
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  setIsModalOpen(false);
                  utils.Modal(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  setIsModalOpen(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddNewUser;
